import React , {Component} from 'react'
import axios from 'axios'
import Swal from 'sweetalert2'
export default class ContactEn extends Component{
  constructor(props){
    super(props)
    this.submit = this.submit.bind(this)
  }
  state = {
    sending : false,
    sent: false,
  }
   submit(event) {
    this.setState({sending : true})
    event.preventDefault();
    const data = new FormData(event.target);
    const name = data.get('nom_complet')
    const organization = data.get('compagnie')
    const phone = data.get('telephone')
    const email = data.get('courriel')
    const comment = data.get('commentaire')
    const language = "english"
    console.log(name)
    axios.post("https://groupegamache.com/json/expert-en-sinistre/contact",{name,organization,phone,email,comment,language})
    .then((response)=>{
        Swal({
          type : `success`,
          title : `Message sent`,
          text : `You're message has been sent.`
        })
        this.setState({sending : false, sent: true})
       document.getElementById('contact_form').reset()
    })
    .catch(error=>{
      console.log(error)
    })
    
  }
	render(){
		return(

			 <div>
       
        <title>GAMEX THE ACCIDENT RECOVERY EXPERT OF ROAD TRANSPORTATION</title>
        <div className="top_nav">
          <div className="container">
            {/*<span className="btn btn-primary btn-sm pull-right" data-toggle="modal" data-target=".login_modal">Connect</span>*/}
            <a href="/expert-en-sinistre/contact" className="btn btn-primary btn-sm  pull-right">FR</a>	
          </div></div>
        <header className>
          <div className="container">
            <div className="row">
              <div className="col-lg-6 col-md-8 col-sm-12 col-xs-12">
                <h1 className="logged en">
                  <span>You can now</span><span>safely let us</span><span>take care of</span><span>everything.</span>					
                </h1>
              </div>
              <div className="col-lg-6 col-md-4 hidden-sm hidden-xs">
                <img className="img-responsive logo" src={require('../assets/img/logo_gamex_en.png')} alt="GAMEX THE ACCIDENT RECOVERY EXPERT OF ROAD TRANSPORTATION" />
              </div>
            </div>
          </div>
        </header>
        <div className="scroller_anchor" />
        <nav id="navigation" className="scroller">
          <ul className="nav">
            <li id="accueil" className="col-md-2 col-sm-3 col-xs-3"><a href="/accident-recovery-expert#header">Home</a></li>
            <li className="col-md-2 col-sm-3 col-xs-3 "><a href="/accident-recovery-expert#gamex_plus">About</a></li>
            <li className="col-md-2 col-sm-3 col-xs-3"><a href="/accident-recovery-expert#pourquoi_gamex">Expertise</a></li>
            <li className="col-md-2 col-sm-3 col-xs-3"><a href="/accident-recovery-expert/contact">Contact Us</a></li>
          </ul>
          <div className="col-md-2 hidden-sm hidden-xs" />
          <div className="col-md-2 hidden-sm hidden-xs" />
        </nav>		
        <section id="contact">
          <div className="container">
            <div className="col-md-6">
              <h2>Contact us {/*not connect*/}</h2>
              <p className="lead">WE ARE ALWAYS AVAILABLE TO TAKE YOUR CALL, 24 HOURS A DAY, 7 DAYS A WEEK.</p>
              Toll-free (Canada and the United States):  <strong>1-866-635-4402</strong>				<hr />
              <a href="tel:18666354402" className="btn btn-primary btn-lg visible-xs">Contact Us</a>
            </div>
            <div className="col-md-6 form_holder">
              <p className="lead">Leave us your contact information and we’ll get back to you promptly.</p>
              {this.state.sending ?'Sending your message ...': ''}
              {this.state.sent ?'Message sent!': ''}
              <form className="form" id="contact_form" onSubmit={this.submit}>
                <div className="form-group">
                  {/*<label for="nom_complet">Nom complet</label>*/}
                  <input type="text" name="nom_complet" id="nom_complet" className="form-control" placeholder="Full name" />
                </div>
                <div className="form-group">
                  {/*<label for="compagnie">Compagnie</label>*/}
                  <input type="text" name="compagnie" id="compagnie" className="form-control" placeholder="Company/Organisation" />
                </div>
                <div className="form-group">
                  {/*<label for="telephone">Téléphone</label>		*/}
                  <input type="text" name="telephone" id="telephone" className="form-control" placeholder="514-555-5555 (required)" required />
                </div>
                <div className="form-group">
                  {/*<label for="courriel">Courriel</label>*/}
                  <input type="text" name="courriel" id="courriel" className="form-control" placeholder="Email@domain.com (required)" required />
                </div>
                <div className="form-group">
                  {/*<label for="commentaire">Commentaire</label>*/}
                  <textarea name="commentaire" id="commentaire" className="form-control" rows={5} cols placeholder="Comments" defaultValue={""} />
                </div>
                <input id="submit" type="submit" className="btn btn-primary" defaultValue="Send" /><div id="response" />
              </form>
            </div>
          </div>
        </section>
        <br/>
        <footer className>
          <div className="container">
            <div className="col-md-12">
              <h1>GAMEX the accident recovery expert</h1>
            </div>
          </div>
        </footer>
        <div className="modal fade login_modal" tabIndex={-1} role="dialog" aria-labelledby="login_modal">
          <div className="modal-dialog modal-sm">
            <form action="modal_login.php" method="post">
              <div className="modal-content">
                <h1>
                  PLEASE LOG IN		</h1>
                <p className="lead">
                  You need to be logged in to access this section.		</p>
                <div className="form-group">
                  <input className="form-control" type="text" name="email" placeholder="Email" required />
                </div>
                <div className="form-group">
                  <input className="form-control" type="password" name="pass" placeholder="Password" required />
                </div>
                <div className="form-group">
                  <button type="submit" name="btn-login" className="btn btn-primary">Connect</button>
                  <hr />
                  <a className href="contact.php">Can’t connect?</a>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>











			)
	}
}


// WEBPACK FOOTER //
// ./src/components/ContactEn.js